import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileAcceptType, UploadType } from '../../../../../hooks';
import { PdfBlockDataItem } from '../../../../../models';
import { CloseWrapper, MediaBlockUpload, MediaBlockUploadPreview } from '../../helpers';

export const PdfNodeView: FunctionComponent<NodeViewProps> = ({
  editor,
  node,
  getPos,
  updateAttributes,
}) => {
  const { t } = useTranslation();

  const items = node.attrs.items as PdfBlockDataItem[];

  const pastedFiles = node.attrs.pastedFiles as File[] | undefined;

  const [loading, setLoading] = useState<boolean>(false);

  const content = useMemo(() => {
    const { pdf = null } = { ...items[0] };

    if (pdf) {
      return <MediaBlockUploadPreview iconId={'pdf'} label={t('richTextEditor.pdf-placeholder')} />;
    }

    return (
      <MediaBlockUpload
        items={items}
        setItems={(items) => updateAttributes({ items })}
        pastedFiles={pastedFiles}
        loading={loading}
        setLoading={setLoading}
        fileAcceptType={FileAcceptType.PDF}
        uploadType={UploadType.PDF}
      />
    );
  }, [items, loading, pastedFiles, t, updateAttributes]);

  return (
    <NodeViewWrapper as={'div'}>
      <CloseWrapper
        editor={editor}
        node={node}
        getPos={getPos}
        loading={Boolean(loading || (pastedFiles?.length && !items.length))}
      >
        {content}
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
